import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import {Button} from "primereact/button";
import { DialogShow } from "../../../components/DialogService/DialogService";


export default function P421DialogSync(props) {

    // const [showDialog, setShowDialog] = useState(false);
    // const [textShow, setTextShow] = useState("");

    const onHide = () => {
        handlerCloseDialog();

    };

    const handlerCloseDialog = () => {
        props.setDialog({ open: false});
    };


    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="ตกลง" icon="pi pi-check-circle" 
                onClick={() => submitForm()} 
                className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
            </div>
        );
    };

    const submitForm = () => {
        props.submitFormSync();
    }

    const onCloseDialog = () => {
        handlerCloseDialog();
        props.setShowDialog(false);
        props.onGetDataList();
        
    }


    return (
        <>
            <Dialog
                blockScroll={true}
                header="Sync ข้อมูลกล้องจากระบบ CIA"
                visible={props.dialog.open}
                modal
                style={{ width: "40vw" }}
                className="p-fluid"
                footer={renderFooter()}
                onHide={() => onHide()} 
            // position='top-right'
            >

                <div style={{ paddingTop: "10px", textAlign: "left" }}>
                    <h5 style={{ margin: "5px", color: "#625f5f", textAlign: "center" }}>กดปุ่ม ตกลง เพื่อทำการ Sync ข้อมูลกล้องจากระบบ CIA</h5>
                    <h5 style={{ margin: "5px", color: "#625f5f", textAlign: "center" }}>หรือกดปุ่ม ยกเลิก เพื่อยกเลิกการทำรายการ</h5>
                </div>

            </Dialog>
            <DialogShow visible={props.showDialog} header="แจ้งเตือน" modal onHide={() => onCloseDialog()} className="p-fluid" textContent={props.textShow} btnCancle={() => onCloseDialog()} />
        </>
    )

}